<template>
  <div class="checkbox radio">
    <input type="radio" :name="name" :id="id" :value="inputValue" v-model="model" />
    <label :for="id">
      <em></em>
      <span>{{ label }}</span>
      <slot name="label" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    label: String,
    modelValue: Array,
    inputValue: String,
    id: String,
    name: String
  },
  computed: {
    model: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
